import { RedireccionMenu } from './redireccion-menu.class';
import { MenuItem } from './menu-item.class';
export class SeleccionProducto {


    contextPath: String;
    opcionEjecutada: String;
    nombreBusqueda: String;
    menuItem: MenuItem;

    constructor() {

        this.contextPath = '';
        this.opcionEjecutada = '';
        this.menuItem = null;
        this.nombreBusqueda = '';
    }





}



// WEBPACK FOOTER //
// ./src/app/models/menu/seleccion-producto.class.ts